<template>
  <div class="mt-2">
    <div v-if="ordemServico"
         class="row">
      <!-- Adicionar nova ordem de serviço -->
      <div class="col">
        <div v-if="ordemServico && !!ordemServico.ordem_servico_id && !ordemServico.registro_id"
             class="row">
          <div class="col-12 text-right mb-2 mt-2">
            <CustomButton
              class="mb-3 mt-2"
              :icon="{type: 'add', size: 'icon--xs', color: 'icons--white'}"
              text="Adicionar Nova Ordem de Serviço"
              @click="novaOrdemServico()" />
          </div>
        </div>
        <sub-header-grey class="mt-2 pt-2 pb-2 pl-3">
          <div class="col">
            <div class="row d-flex justify-content-between align-items-center">
              <div>
                <label class="label">OS {{ ordemServico.numero }} - {{ ordemServico.created_at | date }}</label>
              </div>
              <div v-if="ordemServico.ordem_servico_id">
                <button class="btn btn-sm btn-default btn-excluir"
                        type="button"
                        @click="deleteOS">
                  <IconSvg class="Excluir-icon icon--sm"
                           icon="trash" />
                </button>
              </div>
            </div>
          </div>
        </sub-header-grey>
        <OrdemServicoMensalista :prop-ordem-servico="ordemServico"
                                @check="handlerCheckMensalista"
                                @addMensalista="handlerAddMensalista"
                                @addObservacoes="handlerObservacoes" />

        <div class="row mt-3 mb-3 pl-3">
          <div class="col-3">
            <div class="form-group">
              <custom-input
                name="cpf_solicitante"
                label="CPF/CNPJ do Solicitante"
                validate-type="cpfOrCnpj"
                type="text"
                :required="true"
                :form-erros="formErros"
                :initial-value="ordemServico.cpf_solicitante"
                error-mensage="CPF é um campo obrigatório"
                mask-type="cpf"
                @setError="setError"
                @blur="setValueInput" />
            </div>
          </div>

          <div class="col-5">
            <div class="form-group">
              <CustomInput
                name="nome_solicitante"
                label="Nome do Solicitante"
                :form-erros="formErros"
                :initial-value="ordemServico.nome_solicitante"
                :required="true"
                type="text"
                @setError="setError"
                @blur="setValueInput" />
            </div>
          </div>

          <div class="col-2">
            <CustomInput
              name="data_cumprida"
              label="Data da OS"
              type="date"
              :initial-value="ordemServico.data_cumprida"
              :required="true"
              :form-erros="formErros"
              @setError="setError"
              @blur="setValueInput" />
          </div>
          <div class="col-2 mt-2">
            <div id="div_pedido_crc"
                 class="mt-4 pt-1 ml-3">
              <b-form-checkbox id="pedido_crc"
                               v-model="pedidoCrc"
                               name="pedido_crc"
                               :disabled="ordemServico.ordem_servico_id || ordemServico.itens.length > 1"
                               switch
                               class="label"
                               @change="changePedidoCrc">
                Pedido CRC
                <b-tooltip v-if="ordemServico.itens.length >= 2 && !ordemServico.registro_id"
                           target="div_pedido_crc"
                           triggers="hover">
                  Existe mais de uma custa com selo cadastrada
                </b-tooltip>
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Pedido CRC -->
    <PedidoCrc :prop-pedido-crc="pedidoCrc"
               :prop-ordem-servico="ordemServico"
               :prop-pedido-pendente="propPedidoPendente"
               :prop-pedido-p13="propPedidoP13"
               @updateCRCData="updateCRCData" />
    <!-- Infos Serviços | Listar Itens-->
    <div class="row">
      <div class="col">
        <sub-header-grey v-show="ordemServico && ordemServico.itens && ordemServico.itens.length > 0"
                         class="pt-2 pb-2 pl-3"
                         :class="!showBeneficiario() ? 'mb-3' : ''">
          <label class="label">Serviços</label>
        </sub-header-grey>
        <div>
          <!-- Beneficiario -->
          <div v-show="showBeneficiario()"
               class="row pl-3 pt-3 pb-2">
            <div>
              <div class="float-left">
                <label class="label"
                       :for="`beneficiario_justica_gratuita_${ _uid }`">
                  Beneficiário da justiça gratuita
                </label>
              </div>

              <b-form-checkbox :id="`beneficiario_justica_gratuita_${ _uid }`"
                               v-model="beneficiario"
                               name="check-button"
                               class="float-right ml-2"
                               switch
                               @change="changeBeneficiario()"
                               @keyup.native.enter="changeBeneficiario()" />
            </div>
          </div>

          <!-- usando para listar -->
          <div v-if="ordemServico.itens.length">
            <div v-for="(servicoItem, index) in ordemServico.itens"
                 :key="`item_servico_${ _uid }_${ index }`">
              <BoxOS :prop-item="servicoItem"
                     :prop-index="index"
                     :prop-tipo="propTipo"
                     :prop-registro="propRegistro"
                     :prop-update="updateBoxOs"
                     @deleteItem="onDelete"
                     @editItem="setItemToEdit"
                     @cancelItem="cancelItem(servicoItem, index)"
                     @imprimir="(custa) => imprimir(custa)"
                     @rechargeOS="rechargeOS" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- usando para cancelar selos itremOs -->
    <div v-if="ordemServico.itens.length">
      <CancelarSelosOs
        :show="showCancelarSelo" 
        :item-os="ordemServico.itens[indexItemOs]"
        :index-item-os="indexItemOs"
        @close="(index) => handlerCloseCancelarSelo(index)"
        @confirm="(item, index) => handlerCancelItemSelos(item, index)" />
    </div>
    <div class="row m-3">
      <!-- Botão Adicionar novo Item -->
      <b-button id="addItens"
                class=" btn btn-outline-primary"
                :block="true"
                variant="outline-primary"
                :disabled="ordemServico.itens.length >= 1 && pedidoCrc"
                @click="() => {criarNovoItem = true; showModalItemEdit = true}">
        <IconSvg class="icon-add"
                 icon="add" />
        Adicionar mais itens
      </b-button>
      <div class="container">
        <!-- Usando para criar, editar ou vizualizar itens -->
        <OrdensServicoFormItem :prop-show="showModalItemEdit"
                               :prop-custas="custasAtivas"
                               :prop-tipo="propTipo"
                               :prop-item="criarNovoItem ? false : ordemServico.itens[indexItemOs]"
                               :prop-pedido-crc="pedidoCrc"
                               :prop-registro="propRegistro"
                               @ok="handlerItemOs"
                               @closeModal="() => {showModalItemEdit = false; criarNovoItem = false, itemOsTemporario = null, indexItemOs = null}" />
        <!-- Info Total -->
        <div class="row mt-4">
          <div class="col" />
          <div class="col OrdensServicoForm--ValorTotal">
            <div class="row justify-content-between mt-2">
              <div class="col">
                Total
              </div>
              <div class="col text-right">
                {{ ordemServico.valorTotal() | moneyToString }}
                <span v-if="ordemServico.ordem_servico_id"
                      @click="imprimirRecibo()">
                  <IconSvg icon="print"
                           class="icon--sm  btn-inprimir-recibo" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Cadastro e update Ordem de Serviço -->
        <div class="row justify-content-end">
          <OrdensServicoFormSalvar 
            :prop-disabled="!!formErros.length"
            :prop-ordem-servico="ordemServico"
            :prop-tipo="propTipo"
            :prop-registro="propRegistro"
            :prop-data="propData"
            :prop-pedido-pendente="propPedidoPendente"
            :prop-pedido-p13="propPedidoP13"
            @novaOsCriada="updateOrdemServico"
            @imprimirRecibo="(url) => imprimirReciboUrl(url)"
            @solicitarImpressao="$emit('solicitarImpressao')"
            @onBack="() => this.$emit('onBack')" />
        </div>
        <ModalImpressao :url="pdfUrl"
                        @close="() => pdfUrl = ''" />
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import OrdensServicoFormItem from "@/components/SofiaRei/Resumo/OrdensServico/ordensServicoForm/OrdensServicoFormItem"
  import BoxOS from '../BoxOS'
  import PedidoCrc from "@/components/SofiaRei/Resumo/OrdensServico/ordensServicoForm/PedidosCrc/PedidoCrc"
  import CustomInput from "@/components/CustomInputs/CustomInput"
  import CustomButton from '@/components/CustomButton/CustomButton'
  import OrdensServicoFormSalvar from "./OrdensServicoFormSalvar"
  import CancelarSelosOs from './CancelarSelosOs'
  import OrdemServicoMensalista from '../../../../../views/SofiaRei/FrenteDeCaixa/Mensalistas/OrdemServicoMensalista/OrdemServicoMensalista.vue'
  import ModalImpressao from "@/components/ModalImpressao/ModalImpressao"

  /* services */
  import PessoasService from "@/services/Pessoas"
  import SolicitantesService from "@/services/Registros/SolicitantesService"
  import CustasService from '@/services/Registros/CustasService'

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'
  // outros
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  // Entities
  import OrdemServico from "@/entities/OrdemServico/OrdemServico"
  import OrdemServicoItem from '@/entities/OrdemServicoItem/OrdemServicoItem'
  import { useCaseOrdemServico } from "@/entities/OrdemServico/useCaseOrdemServico.js"
  // Utils
  import { displayQuestion } from '@/utils/displayQuestion.js'

  export default {
    name: "OrdensServicoForm",

    components: {
      SubHeaderGrey,
      OrdensServicoFormItem,
      BoxOS,
      PedidoCrc,
      CustomInput,
      OrdensServicoFormSalvar,
      CancelarSelosOs,
      CustomButton,
      OrdemServicoMensalista,
      ModalImpressao
    },

    props: {
      propTipo: {
        type: String,
        default: ''
      },
      propCustas: {
        type: Array,
        default: () => []
      },
      propOrdemServico: {
        type: Object,
        default: () => {}
      },
      propNovo: {
        type: Boolean,
        default: false
      },
      propNovoProcedimento: {
        type: Boolean,
        default: false
      },
      propGerarCpf: {
        type: Boolean,
        default: false
      },
      propRegistro: { type: Object, default: () => { return {} }},
      propData: { type: Object, default: null },
      propProcedimentos: { type: Boolean, default: false },
      propPedidoPendente: {type: Object, default: () => {}},
      propPedidoP13: {type: Object, default: () => {}},
    },
    data () {
      return {
        desabilitarBotao: true,
        itemOsTemporario: {},
        criarNovoItem: false,
        indexItemOs: null, // reset o valor após o uso para evitar conflito uma vez que essa campo é usado em mais de um contexto
        show: { nome_solicitante: false },
        showCancelarSelo: false,
        formErros: [],
        beneficiario: false,
        ordemServico: new OrdemServico(),
        showModalItem: false,
        showModalItemEdit: false,
        itemEdit: {},
        pedidoCrc: false,
        updateBoxOs: false,
        custasAtivas: [],
        checkMensalista: false,
        pdfUrl: '',
        pedidoPendente: {},
      }
    },

    computed: {
      ...mapGetters({
        procedimento: 'procedimento/getProcedimento',
        solicitanteProcedimento: 'procedimento/getRequerente',
        cartorioObj: 'auth/getCartorioObj',
        zerarCustas: 'procedimento/getZerarCustas',
        inteiroTeor: 'procedimento/getInteiroTeor',
        alteracaoEstadoCivil: 'procedimento/getAlteracaoEstadoCivil',
        impressaoReciboOSPdfUrl: 'impressaoReciboOS/getPdfUrl'
      })
    },

    watch: {
      propOrdemServico () {
        this.init()
      },
      'ordemServico.itens' () {
        if (this.ordemServico.itens.length) {
          this.formErros = this.formErros.filter(obj => obj !== 'itens')
          return
        }
        this.formErros.push('itens')
      },
      'ordemServico.uf_cartorio' () {
        if (this.ordemServico.uf_cartorio) {
          this.pedidoCrc = true
        }
      },
      impressaoReciboOSPdfUrl (novoValor, antigoValor) {
        if (novoValor !== antigoValor) this.pdfUrl = novoValor
      }
    },
    beforeMount () {
      this.init()
    },
    methods: {
      async init () {
        if (this.propCustas.length) {
          this.custasAtivas = this.propCustas
        } else await this.getCustas()

        if (this.propOrdemServico) {
          this.ordemServico = new OrdemServico(this.propOrdemServico) 
          this.ordemServico.data_cumprida = moment(this.propOrdemServico.data_cumprida).format('YYYY-MM-DD')
        }

        if (this.ordemServico && (this.ordemServico.num_pedido_crc || this.ordemServico?.itens.find(item => !!item.ordemServicoItemIndependente))) {
          this.pedidoCrc = true
        }

        if (!!this.solicitanteProcedimento && !!this.procedimento) {
          const { nome, cpf } = this.solicitanteProcedimento
          this.$set(this.ordemServico, 'cpf_solicitante', cpf)
          this.$set(this.ordemServico, 'nome_solicitante', nome)
        }

        if(this.propPedidoP13){
          this.pedidoCrc = true
        }

        if (this.propPedidoPendente && Object.keys(this.propPedidoPendente).length) {
          this.pedidoCrc = true

          const { documento_requerente, nome_requerente, data_pedido } = this.propPedidoPendente

          if (documento_requerente) this.ordemServico.cpf_solicitante = documento_requerente
          if (nome_requerente) this.ordemServico.nome_solicitante = nome_requerente
        }

        this.openNovo()
      },

      async getCustas () {
        const custas =  await CustasService.getCustas({
          cartorio_id: this.cartorioObj.cartorio_id,
          perPage: 200,
          os: 1,
          ativo: true
        })
        this.custasAtivas = custas.data
        this.$store.dispatch('custa/setCustasAtivas', this.custasAtivas)   
      },
      updateOrdemServico (os) {
        this.ordemServico = os
      },
      setValueInput (nome, value) {    
        this.ordemServico[nome] = value
        if (nome === 'cpf_solicitante') this.searchSolicitante()
      },
      setError (newArray) {
        this.formErros = newArray
      },
      showBeneficiario () {
        let validate = false
        if (this.ordemServico?.itens.length > 0) {
          validate = true
        }
        this.ordemServico?.itens.filter(item => {
          if (item.ordem_servico_item_id) {
            validate = false
          }
        })
        return validate
      },
      changeBeneficiario () {
        this.beneficiario = !this.beneficiario
        if (this.beneficiario) {
          this.ordemServico?.itens.map((item) => {
   
            item.zerarCusta = true
          })
        } else {
          this.ordemServico?.itens.map((item) => {
      
            item.zerarCusta = false
          })
        }
      },
      updateItemTemporario (itemOs) { // usada para atualizar item editado
        this.ordemServico.itens[this.indexItemOs] = itemOs
      },
      handlerItemOs (item) { // usada para adicionar um novo item a ordem de serviço
        if (this.criarNovoItem || this.propNovo && !this.indexItemOs) {
          this.ordemServico.setItemOrdemServico(item)
        }
        if (!this.criarNovoItem && this.indexItemOs !== null) {
          this.ordemServico.itens[this.indexItemOs] = item
        }
        this.indexItemOs = null
        this.showModalItemEdit = false
        this.criarNovoItem = false
      },
      cancelItem (item, index) {
        // Atualiza status do selo para update
        if (!item.flag_cancelado) {
          this.indexItemOs = index
          this.showCancelarSelo = true
        } else {
          this.ordemServico.itens[index].flag_cancelado = false
          for (const itemOs of this.ordemServico.itens[index].seloItemOs) {
            itemOs.selo.cancelado_tj = false
            itemOs.selo.excluido_tj = false
            itemOs.selo.retificarSelo = true
          }    
        }

      },
      onDelete (index) {
        this.ordemServico.itens.splice(index, 1)
      },
      setItemToEdit (index) {
        this.indexItemOs = index
        this.criarNovoItem = false
        this.showModalItemEdit = true
        this.updateBoxOs = false
      },
      onEdit () {
        this.updateBoxOs = true
        this.showModalItemEdit = false
      },
      async searchSolicitante () {
        const solicitante = await SolicitantesService.getSolicitantes({
          cartorio_id: this.$store.state.auth.cartorio_id,
          cpf: this.ordemServico?.cpf_solicitante
        })
        if (solicitante.data  && solicitante.data.length > 0) {
          this.ordemServico.nome_solicitante = solicitante.data[0].nome
          this.show.nome_solicitante = true
        } else if (this.ordemServico?.cpf_solicitante) {
          let cpf = filterMaskedNumber(this.ordemServico.cpf_solicitante)
          
          this.formErros = this.formErros.filter((item) => item !== 'nome_solicitante')
          if (cpf && cpf.length > 10) {
            const dados = await PessoasService.getPessoaByCPF(cpf)

            if (dados.isEmpty) return

            this.ordemServico.nome_solicitante = dados.nome
          }
        }
      },
      imprimir (custa)  {
        this.$emit('imprimir', custa)
      },
      async deleteOS () {
        try {
          loader({ text: 'Aguarde...', active: true })

          const question = await displayQuestion(
            'Atenção', 
            'Tem certeza que deseja excluir essa ordem de serviço?', 
            'Sim', 'Não', 
            'Exclusão cancelada!')
          if (!question) return

          await new useCaseOrdemServico(this.ordemServico).delete()

          this.$router.push('/ordens-servicos')
        } catch (error) {
          const message = error.message
          displayMessage('error', 'Error!', message)
        } finally {
          loader({ text: '', active: false })
        }

      },
      async imprimirRecibo () {
        const url = await new useCaseOrdemServico(this.ordemServico).imprimirRecibo(this.propTipo, this.propRegistro,this.propData) 
        this.pdfUrl = url
      },
      changePedidoCrc () {
        this.pedidoCrc = !this.pedidoCrc
        if (!this.pedidoCrc) this.resetPedidoCRC()
      },
      resetPedidoCRC () {
        this.ordemServico.num_pedido_crc = null
        this.ordemServico.uf_cartorio = null
        this.ordemServico.valor_da_custa = null
        this.ordemServico.num_matricula_registro = null
      },
      rechargeOS () {
        this.$emit('rechargeOS')
      },
      novaOrdemServico () {
        this.$router.push('/ordem-servico/novo')
      },
      updateCRCData (name, value) {
        this.ordemServico[name] = value
      },
      handlerCancelItemSelos (item) {
        this.ordemServico.itens[this.indexItemOs] = item
        this.indexItemOs = null // reseta o valor do index transitorio para evitar conflitos
        this.showCancelarSelo = false
      },
      handlerCloseCancelarSelo (index) {

        // Resetando ações:
        this.ordemServico.itens[index].flag_cancelado = false
        for (const itemOs of this.ordemServico.itens[index].seloItemOs) {
          itemOs.selo.cancelarSelo = false
          itemOs.selo.excluirSelo = false
        }  

        this.indexItemOs = null // reseta o valor do index transitorio para evitar conflitos
        this.showCancelarSelo = false
      },
      openNovo () {
        if (this.inteiroTeor || this.alteracaoEstadoCivil || this.propNovo && this.custasAtivas.length > 0 && !this.propPedidoPendente) {
          const custasPreSelecionadas = []
          if (['obito', 'nascimento'].indexOf(this.propTipo) >= 0 && !this.inteiroTeor && !this.alteracaoEstadoCivil) {
            const custa = this.custasAtivas.find(custa => custa.codigo === 16)

            if (custa) {
              custasPreSelecionadas.push(custa)
            }
          }

          if (this.propTipo === 'casamento' && !this.alteracaoEstadoCivil && !this.inteiroTeor) {
            const custas = this.custasAtivas.filter(custa => [17, 18].indexOf(custa.codigo) >= 0)
            if (custas.length) {
              custasPreSelecionadas.push(...custas)
            }
          } else if (this.propTipo === 'casamento' && this.alteracaoEstadoCivil) {
            const custas = this.custasAtivas.filter(custa => [8, 17].indexOf(custa.codigo) >= 0)

            if (custas.length) {
              custasPreSelecionadas.push(...custas)
            }
          } else if (this.inteiroTeor && !!this.propProcedimentos) {
            const custas = this.custasAtivas.filter(custa => [10].indexOf(custa.codigo) >= 0)

            if (custas.length) {
              custasPreSelecionadas.push(...custas)
            }
          }

          for (const custaPreSelecionada of custasPreSelecionadas) {
            const item = new OrdemServicoItem()

            let tipoRegistro = this.propTipo

            // Verificamos o tipo do registro para tratar caso seja um Natimorto  
            tipoRegistro = !!this.propRegistro && this.propRegistro.tipo_registro == 'NT' ? 'natimorto' : this.propTipo

            item.setCusta(custaPreSelecionada, tipoRegistro)
            this.ordemServico.setItemOrdemServico(item)  
          }

          // Devemos sempre reseta
          this.$store.dispatch('procedimento/updateZerarCustas', false)
        }
      },
      handlerCheckMensalista () {
        if (this.ordemServico.id_mensalista) {
          this.checkMensalista = false
          this.resetData()
          return
        }
        this.checkMensalista = !this.checkMensalista
      },
      handlerAddMensalista (mensalista) {
        this.ordemServico.id_mensalista = mensalista.mensalista_id
        this.ordemServico.nome_solicitante = mensalista.nome_empresa
        this.ordemServico.cpf_solicitante = mensalista.cpf_cnpj
        this.checkMensalista = false
      },
      handlerObservacoes (obsText) {
        this.ordemServico.observacoes = obsText
      },
      resetData () {
        Object.assign(this.$data, this.$options.data())
      },
      imprimirReciboUrl (url) {
        this.pdfUrl = url
      }
    },
  }

</script>

<style scoped lang="scss">
  .OrdensServicoForm {
    &--ValorTotal {
      height: 47px;
      background: #C6C6C6 0% 0% no-repeat padding-box;
      border-radius: 2px 2px 0px 0px;
      opacity: 1;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .btn-gigante {
    width: 100%;

  }

  .btn-gigante:hover > [class*=icon-add] {
    fill: #fff;
  }
  .icon-add {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
    transition: fill 0.2s;
  }
    .icon-delete {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
  }

  .Excluir {
      &-icon, svg {
        fill: #8b0000;
        width: 20px;
      }
  }

  .btn-excluir {
    padding: 0;
    margin: 0 0 0 30px;
  }

  .btn-inprimir-recibo {
    cursor: pointer;
  }

  .btn-inprimir-recibo:active {
    transform: scale(0.98);
  }

</style>
